import ModalUI from "../ui/ModalUI";
import CustomButton from "../CustomButton";
import DeleteIcon from "../Inputs/DeleteIcon";
import Styles from "./RiskTaskModal.module.css";

function RiskLessonTaskModalUI({
  show,
  handleClose,
  title = "Modal",
  formFields,
  onSubmit,
  submitLabel = "Submit",
  submitting = false,
  list = [],
  loading = false,
  onDelete,
  renderItem,
  emptyMessage = "No items to display.",
}) {
  return (
    <ModalUI
      show={show}
      handleClose={handleClose}
      title={title}
      size="lg"
      zIndex={1060}
    >
      <div className={Styles.container} style={{ maxHeight: "52vh", overflow: "auto" }}>
        {/* Form Section */}
        <form onSubmit={onSubmit}>
          <div className="p-1">  
          {formFields}
          </div>
          <div className="d-flex justify-content-center my-3">
            <CustomButton type="submit" disabled={submitting}>
              {submitting ? "Submitting..." : submitLabel}
            </CustomButton>
          </div>
        </form>

        {/* List Section */}
        <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
          {loading ? (
            <p>Loading...</p>
          ) : list.length > 0 ? (
            list.map((item) => (
              <div key={item.id} className="p-3 mb-2 border rounded">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="w-100">{renderItem(item)}</div>
                  {onDelete && (
                    <DeleteIcon size={14} id={item.id} onDelete={() => onDelete(item.id)} />
                  )}
                </div>
              </div>
            ))
          ) : (
            <p className="d-flex p4 justify-content-center">{emptyMessage}</p>
          )}
        </div>
      </div>
    </ModalUI>
  );
}

export default RiskLessonTaskModalUI;
